//import BBOrderService from './BBOrderService';
import OrderService from './OrderService';
import InvoiceService from './InvoiceService';
import BBOrderBevestigingService from './BBOrderBevestigingService';
import OrderConfirmationService from './OrderConfirmationService';
import OAuth2AzureService from './OAuth2AzureService';
import WebSocketService from './WebSocketService';
import CustomerService from './CustomerService';
import LogService from './LogService';
import DebtorService from './DebtorService';
import PdfParsingService from './PdfParsingService';
import UserRolesService from './UserRolesService';
import PdfParseQueueService from './PdfParseQueueService';
import AppSettingsService from './AppSettingsService';

class ServiceFactory {
  orderService = null;
  invoiceService = null;
  orderBevestigingService = null;
  orderConfirmationService = null;
  oAuth2AzureService = null;
  webSocketService = null;
  customerService = null;
  logService = null;
  debtorService = null;
  pdfParsingService = null;
  userRolesService = null;
  pdfParseQueueService = null;
  appSettingsService = null;

  static getService(serviceType) {
    switch (serviceType) {
      case 'OrderService':
        if (!this.orderService) {
          this.orderService = new OrderService();
        }
        return this.orderService
      case 'InvoiceService':
        if (!this.invoiceService) {
          this.invoiceService = new InvoiceService();
        }
        return this.invoiceService
      case 'WebSocketService':
        if (!this.webSocketService) {
          this.webSocketService = new WebSocketService();
        }
        return this.webSocketService
      case 'OrderBevestigingService':
        if (!this.orderBevestigingService) {
          this.orderBevestigingService = new BBOrderBevestigingService();
        }
        return this.orderBevestigingService
      case 'OrderConfirmationService':
        if (!this.orderConfirmationService) {
          this.orderConfirmationService = new OrderConfirmationService();
        }
        return this.orderConfirmationService
      case 'OAuth2AzureService':
        if (!this.oAuth2AzureService) {
          this.oAuth2AzureService = new OAuth2AzureService();
        }
        return this.oAuth2AzureService
      case 'CustomerService':
        if (!this.customerService) {
          this.customerService = new CustomerService();
        }
        return this.customerService
      case 'LogService':
        if (!this.logService) {
          this.logService = new LogService();
        }
        return this.logService
      case 'DebtorService':
        if (!this.debtorService) {
          this.debtorService = new DebtorService();
        }
        return this.debtorService
      case 'PdfParsingService':
        if (!this.pdfParsingService) {
          this.pdfParsingService = new PdfParsingService();
        }
        return this.pdfParsingService
      case 'UserRolesService':
        if (!this.userRolesService) {
          this.userRolesService = new UserRolesService();
        }
        return this.userRolesService
      case 'PdfParseQueueService':
        if (!this.pdfParseQueueService) {
          this.pdfParseQueueService = new PdfParseQueueService();
        }
        return this.pdfParseQueueService
      case 'AppSettingsService':
        if (!this.appSettingsService) {
          this.appSettingsService = new AppSettingsService();
        }
        return this.appSettingsService
      default:
        throw new Error(`Unknown service type: ${serviceType}`);
    }
  }
}

export default ServiceFactory;
